module.exports = __webpack_public_path__ + "assets/pdf/Terms&Conditions.fb4a94bd.pdf";